import React from 'react'
import { Component } from 'react'
import Head from 'next/head'
import PageLink from 'Components/PageLink'

import AppBar from 'Components/AppBar'
import { ViewType as AppBarViewType } from 'Components/AppBar/AppBar'
import AddressDisplay from 'Components/Cart/AddressDisplay'
import Button from 'Components/Button'
import CartTable from 'Components/Cart/CartTable'
import CartSummary from 'Components/Cart/CartSummary'
import DeliveryDiscount from 'Components/Cart/DeliveryDiscount'
import ScrollIntoViewButton from 'Components/ScrollIntoViewButton'
import { CheckoutStage } from 'Utils/helpers/constants'

import { SVGList, SVGTrashSmall, SVGIconWarningLabel, SVGShippingCar, SVGShipping2, SVGDropPackage, SVGPackage, SVGLink } from 'Components/SVGCollection'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import btnCss from 'Components/Button/Button.scss'
import stepper from 'Components/Checkout/Stepper/Stepper.scss';
import cl from 'Scss/pages/cart.scss'
import { connect, DispatchProp } from 'react-redux'
import { CartFragment, getCheckoutInfo_shippingMethods, updateCart, updateCartVariables, getCheckoutInfoVariables, getCheckoutInfo, getCheckoutInfo_shippingMethods_ShippingMethodGPoint, getCheckoutInfo_shippingMethods_ShippingMethodMpl, getCheckoutInfo_shippingMethods_ShippingMethodGRoby, getCheckoutInfo_shippingMethods_ShippingMethodPostPoint, ShippingMethodFragment_ShippingMethodGRoby, ShippingMethodFragment_ShippingMethodMpl, ShippingMethodFragment_ShippingMethodPostPoint, ShippingMethodFragment_ShippingMethodGPoint, ShippingMethodFragment, linkableOrders_linkableOrders, CartFragment_cart_products } from 'Utils/api/gql/types'
import { showMessage, showDeliveryTypeModal, asyncDeleteDialog, showLinkingOrdersModal } from 'Utils/helpers/modalHelper'
import { cartRequestDeleteAllItems, setCart, refreshCheckoutInfo, setDeliveryAddress } from 'Utils/redux/actions'
import animateScrollTo from 'animated-scroll-to'
import CheckoutHelper from 'Utils/helpers/checkoutHelper'
import CartHelper from 'Utils/helpers/cartHelper'
import _app from './_app';
import { updateCartMutation } from 'Utils/api/gql/mutations/updateCart';
import { FREE_SHIPPING_LIMIT, SHOW_FREE_SHIPPING_LIMIT as SHOW_FREE_SHIPPING_MINIMUM } from 'Utils/helpers/constants';
import get from 'lodash/get'
import chunk from 'lodash/chunk'
import { parseErrors, collectAllErrorsForModal } from 'Utils/helpers/errorHelper';
import uiEventEmitter, { UIEvents } from 'Utils/uiEventEmitter';
import { SaveCartToListModal } from 'Components/Profile/ShoppingList/ShoppingList';
import { getCheckoutInfoQuery } from 'Utils/api/gql/queries/getCheckoutInfo';
import Stepper from 'Components/Checkout/Stepper';
import Box from 'Components/Box';
import Spinner from 'Components/Spinner';
import { pushRoute } from 'Utils/helpers/routerHelper';
import gtmClientInstance, { GtmCheckoutStep } from 'Utils/gtmClient';
import Logger from 'Utils/Logging'
import DropdownSelect from 'Components/Dropdown/DropdownSelect';
import { ShippingMethodFragment_ShippingMethodMpl_price_ranges } from "../utils/api/gql/types";
import { priceRangeFormatter } from "../utils/helpers/formatters";
import { cartHandleProductErrors } from "../utils/redux/actions";
import CartCoupon from 'Components/CartCoupon'

type CartOrder = "default" | "alphabetical"
const cartSorters: { [s in CartOrder]: (cp: Array<CartFragment_cart_products>) => Array<CartFragment_cart_products> } = {
  alphabetical: (a) => [...a].sort((a,b) => a.product.name.localeCompare(b.product.name, 'hu-HU')),
  default: (a) => [...a].reverse()
}

type ReduxProps = {
  cart: CartFragment | null
  session: Redux.IStoreSessionData
  orderData: Redux.IOrderData
  linkableOrders: linkableOrders_linkableOrders[]
  deliveryAddress: Redux.IDeliveryAddress | undefined
  isMobile: boolean
} & DispatchProp

type StateType = {
  coupon: string
  couponError: string
  checkoutInfoFetching: boolean
  shippingMethodsAvailable: getCheckoutInfo_shippingMethods[]
  shippingMethodNameSelected: Redux.ShippingMethodCode | null
  showScrollToBottom: boolean
  cartOrder: CartOrder
}

type availableShippingMethodsType = getCheckoutInfo_shippingMethods_ShippingMethodGPoint | getCheckoutInfo_shippingMethods_ShippingMethodMpl | getCheckoutInfo_shippingMethods_ShippingMethodGRoby | getCheckoutInfo_shippingMethods_ShippingMethodPostPoint

const isShippingMethodAvailable = (methodName: string, shippingMethods: availableShippingMethodsType[]) => {
  return typeof shippingMethods.find(item => item.__typename === methodName) !== 'undefined'
}

function getAvailableShippingMethodByMethodName<T extends availableShippingMethodsType> (methodName: T["__typename"], shippingMethods: availableShippingMethodsType[]): T | null {
  const found = shippingMethods.find(item => item.__typename === methodName)
  if (found && found.__typename === methodName) {
    return found as T
  }
  return null
}

function tooltipForPriceRanges(priceRanges: ShippingMethodFragment_ShippingMethodMpl_price_ranges[]): string {
  return [...priceRanges]
    .sort((a,b) => a.from - b.from)
    .map(priceRangeFormatter)
    .join('\n')
}

function priceOrErrorForShippingMethod(method: ShippingMethodFragment): string {
  if (method.errors && method.errors.some(e => !!e && e.__typename === 'ShippingMethodErrorPostcode')){
    // TODO TEMPORARY
    // return 'Nem elérhető'
    return "";
  }
  if ((method.__typename === 'ShippingMethodMpl' || method.__typename === 'ShippingMethodPostPoint') && method.price_ranges) {
    const maxPriceRange = method.price_ranges && method.price_ranges.sort((a, b) => b.price - a.price)[0];

    if (typeof maxPriceRange === "undefined" || maxPriceRange.price === 0) {
      return "Ingyenes";
    }

    return `${maxPriceRange.price} Ft`
  }
  if (method.discount_price === 0 || method.price === 0) {
    return 'Ingyenes'
  }
  if (method.__typename === 'ShippingMethodGRoby') {
    return `0 - ${method.discount_price || method.price} Ft`
  }
  return `${method.discount_price || method.price} Ft`
}

class CartPage extends Component<ReduxProps, StateType> {
  containerDiv: HTMLDivElement | null = null
  cartHeadingRef: HTMLHeadingElement | null = null

  constructor (props: ReduxProps) {
    super(props)
    this.state = {
      coupon: '',
      couponError: '',
      checkoutInfoFetching: false,
      shippingMethodsAvailable: [],
      shippingMethodNameSelected: get(props, 'cart.shipping_method.__typename', null),
      showScrollToBottom: false,
      cartOrder: 'default'
    }
  }

  componentDidMount() {
    this.props.dispatch(refreshCheckoutInfo())
    this.fetchCheckoutInfo(this.state.shippingMethodNameSelected)
    window.addEventListener('scroll', this.handleScroll)
    this.props.dispatch(cartHandleProductErrors())
    gtmClientInstance.cartPage(this.props.cart);
  }

  componentDidUpdate(prevProps: ReduxProps) {
    if (prevProps.deliveryAddress !== this.props.deliveryAddress) {
      Logger.debug('REFRESHED Delivery methods for selected address')
      this.fetchCheckoutInfo()
    }

    if (prevProps.cart !== this.props.cart) {
      this.fetchCheckoutInfo(this.state.shippingMethodNameSelected)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    if (!this.cartHeadingRef || !this.containerDiv) {
      return
    }
    const scrolledToBottom = window.scrollY > document.body.clientHeight - window.innerHeight - 100
    if ((window.scrollY > this.cartHeadingRef.offsetTop && !scrolledToBottom) && !this.state.showScrollToBottom) {
      this.setState({ showScrollToBottom: true })
    }
    if ((window.scrollY < this.cartHeadingRef.offsetTop || scrolledToBottom) && this.state.showScrollToBottom) {
      this.setState({ showScrollToBottom: false })
    }
  }

  fetchCheckoutInfo = async (setMethodIfAvailable: Redux.ShippingMethodCode | null = null) => {
    const cartId = get(this.props, 'cart.id', null)
    const postcode = get(this.props, 'deliveryAddress.value.zip', null)
    if (!cartId) {
      return
    }
    this.setState({ checkoutInfoFetching: true })
    try {
      const result = await _app.apolloClient.query<getCheckoutInfo, getCheckoutInfoVariables>({
        query: getCheckoutInfoQuery,
        fetchPolicy: "no-cache",
        variables: {
          cartId,
          postcode
        }
      })
      const availableMethods = result.data.shippingMethods.filter(item => item !== null) as getCheckoutInfo_shippingMethods[]
      const selectableMethods = availableMethods.filter(method => !method.errors || method.errors.every(error => !error || error.__typename !== 'ShippingMethodErrorPostcode'))
      const preferredMethod: Redux.ShippingMethodCode = this.props.deliveryAddress
        ? CheckoutHelper.getPreferredShippingMethod(this.props.deliveryAddress.selected, availableMethods)
        : 'ShippingMethodGRoby'

      let selectedMethodName = setMethodIfAvailable

      if (selectedMethodName === null || !selectableMethods.find(method => method.__typename === selectedMethodName)) {
        selectedMethodName = preferredMethod
      }

      if (preferredMethod === 'ShippingMethodGPoint') {
        selectedMethodName = 'ShippingMethodGPoint'     // force personal if that's in deliveryAddress
      }

      this.setState({
        shippingMethodsAvailable: availableMethods,
        shippingMethodNameSelected: selectedMethodName
      }, () => {
        // uiEventEmitter.emit(UIEvents.END_LOADING)
      })
    } catch {
      // TODO: Mi van ha nem tudjuk lekérdezni?
      // uiEventEmitter.emit(UIEvents.END_LOADING)
    } finally {
      this.setState({ checkoutInfoFetching: false })
    }
    // uiEventEmitter.emit(UIEvents.END_LOADING)
  }

  handleDeleteAllClick = async () => {
    if (await asyncDeleteDialog('Biztos, hogy kiüríti a kosarát?', 'Kosár ürítése') === 'yes') {
      this.props.dispatch(cartRequestDeleteAllItems())
    }
  }

  scrollIntoView = () => {
    animateScrollTo(document.body.scrollHeight)
  }

  unlinkOrder = async () => {
    if (await asyncDeleteDialog('Biztosan szétkapcsolod a megrendelést?', 'Szétkapcsolom') !== 'yes') {
      return
    }
    try {
      uiEventEmitter.emit(UIEvents.START_LOADING)
      const result = await _app.apolloClient.mutate<updateCart, updateCartVariables>({
        mutation: updateCartMutation,
        variables: {
          input: {
            id: this.props.cart!.id,
            linked_order_id: null
          }
        }
      })

      if (result.data && result.data.updateCart) {
        uiEventEmitter.emit(UIEvents.END_LOADING)
        this.props.dispatch(setCart(result.data.updateCart, true))
        showMessage('Megrendelésedet szétkapcsoltuk!')
      } else throw new Error('')
    } catch (e) {
      uiEventEmitter.emit(UIEvents.END_LOADING)

      showMessage('Hiba történt a megrendelések szétkapcsolása közben.')
      return
    }
  }

  updateCouponCode = async () => {
    const { cart } = this.props
    if (!cart || !this.state.coupon) return

    const selectedMethod = this.state.shippingMethodNameSelected
      ? getAvailableShippingMethodByMethodName(this.state.shippingMethodNameSelected, this.state.shippingMethodsAvailable)
      : null;

    if (selectedMethod && CheckoutHelper.methodHasAnyError(selectedMethod)) {
      showMessage("A kosarad a megadott szállítási mód tömegkorlátját meghaladja, vagy az adott szállítási móddal nem rendelhető terméket tartalmaz. A kuponkód érvényesítéséhez kérünk, előbb módosítsd a kosarad vagy a szállítási módot!")
      return
    }

    try {
      const result = await _app.apolloClient.mutate<updateCart, updateCartVariables>({
        mutation: updateCartMutation,
        variables: {
          input: {
            id: cart.id,
            shipping_method_id: selectedMethod ? selectedMethod.id : undefined,
            coupon_code: this.state.coupon
          }
        }
      })

      if (result.data && result.data.updateCart) {
        showMessage('Kuponkódodat érvényesítettük!')
        this.props.dispatch(setCart(result.data.updateCart))
        this.setState({ couponError: '' })
      }
    } catch (e) {
      const couponError = get(e, 'graphQLErrors.0.extensions.validation.input.coupon_code.0')
      if (couponError) {
        this.setState({ couponError })
      } else {
        const parsed = parseErrors(e)
        this.setState({ couponError: parsed.general || 'Ismeretlen hiba történt' })
      }
    }
  }

  deleteCoupon = async () => {
    try {
      const result = await _app.apolloClient.mutate<updateCart, updateCartVariables>({
        mutation: updateCartMutation,
        variables: {
          input: {
            id: this.props.cart!.id,
            coupon_code: null
          }
        }
      })
      if (result.data && result.data.updateCart) {
        this.props.dispatch(setCart(result.data.updateCart))
      }
    } catch (e) {
      showMessage('Hiba történt a kupon törlése közben!')
    }
  }

  saveToShoppingListFinished = (wasSuccess:boolean) => {
    if (wasSuccess) {
      showMessage('Bevásárlólistád elkészült!')
    } else {
      showMessage('Hiba történt a bevásárlólista létrehozása közben, kérlek próbáld meg később :(')
    }
  }

  selectMethod = (methodName: Redux.ShippingMethodCode) => {
    if (methodName === 'ShippingMethodGPoint') {
      this.props.dispatch(setDeliveryAddress({ selected: { type: 'personal' }, value: { zip: null, city: null, addressId: null }}, true))
    } else {
      const isPersonalShipping = get(this.props, 'deliveryAddress.selected.type', null) === 'personal'
      if (isPersonalShipping) {
        this.props.dispatch(setDeliveryAddress({ selected: { type: 'delivery', deliveryType: this.props.session.loggedIn ? 'savedAddress' : 'postcode' }, value: { zip: null, city: null, addressId: null }}, true))
        this.forceUpdate(() => showDeliveryTypeModal(true, () => {
          this.fetchCheckoutInfo(methodName)
        }));
      } else {
        this.setState({
          shippingMethodNameSelected: methodName
        })
      }
    }
  }

  renderMethodBoxGroby = (methodData: ShippingMethodFragment_ShippingMethodGRoby | null) => {
    if (!methodData) {
      return null
    }
    const isGrobyAvailable = !methodData.errors || methodData.errors.every(e => !e || e.__typename !== 'ShippingMethodErrorPostcode')
    const isPersonalShipping = get(this.props, 'deliveryAddress.selected.type', null) === 'personal'
    let isEnabled = isGrobyAvailable || isPersonalShipping

    return (
      <Box
        title={methodData.name}
        Icon={SVGShippingCar}
        price={priceOrErrorForShippingMethod(methodData)}
        selected={this.state.shippingMethodNameSelected === methodData.__typename}
        value={methodData.__typename}
        onSelect={this.selectMethod}
        disabled={!isEnabled}
        key="groby"
      >
        {!isEnabled ? 'A mai napon felvehető rendelési kapacitásunk megtelt! Megrendelésedet Budapestre és környékére legközelebb a következő napon 00.00 perctől adhatod le.' : methodData.short_description}
      </Box>
    )
  }

  renderMethodBoxMPL = (methodData: ShippingMethodFragment_ShippingMethodMpl | null) => {
    if (!methodData) {
      return null
    }
    return (
      <Box
        title={methodData.name}
        Icon={SVGShipping2}
        tooltip={methodData.price_ranges ? tooltipForPriceRanges(methodData.price_ranges) : undefined}
        price={priceOrErrorForShippingMethod(methodData)}
        selected={this.state.shippingMethodNameSelected === methodData.__typename}
        value={methodData.__typename}
        onSelect={this.selectMethod}
        key="mpl"
      >
        {methodData.short_description}
      </Box>
    )
  }

  renderMethodBoxPostPoint = (methodData: ShippingMethodFragment_ShippingMethodPostPoint | null) => {
    if (!methodData) {
      return null
    }
    return (
      <Box
        title={methodData.name}
        Icon={SVGDropPackage}
        tooltip={methodData.price_ranges ? tooltipForPriceRanges(methodData.price_ranges) : undefined}
        price={priceOrErrorForShippingMethod(methodData)}
        value={methodData.__typename}
        selected={this.state.shippingMethodNameSelected === methodData.__typename}
        onSelect={this.selectMethod}
        key="postpoint"
      >
        {methodData.short_description}
      </Box>
    )
  }

  renderMethodBoxGPoint = (methodData: ShippingMethodFragment_ShippingMethodGPoint | null) => {
    if (!methodData) {
      return null
    }
    return (
      <Box
        title={methodData.name}
        Icon={SVGPackage}
        price={priceOrErrorForShippingMethod(methodData)}
        value={methodData.__typename}
        selected={this.state.shippingMethodNameSelected === methodData.__typename}
        onSelect={this.selectMethod}
        key="gpoint"
      >
        {methodData.short_description}
      </Box>
    )
  }

  renderAvailableMethods = () => {
    const itemTypesToBeRendered = this.state.shippingMethodsAvailable.map(sm => sm.__typename).filter((methodName) => isShippingMethodAvailable(methodName, this.state.shippingMethodsAvailable))
    const itemsRendered = itemTypesToBeRendered.map(typeName => {
      switch(typeName) {
        case 'ShippingMethodGRoby': return this.renderMethodBoxGroby(getAvailableShippingMethodByMethodName(typeName, this.state.shippingMethodsAvailable))
        case 'ShippingMethodMpl': return this.renderMethodBoxMPL(getAvailableShippingMethodByMethodName(typeName, this.state.shippingMethodsAvailable))
        case 'ShippingMethodPostPoint': return this.renderMethodBoxPostPoint(getAvailableShippingMethodByMethodName(typeName, this.state.shippingMethodsAvailable))
        case 'ShippingMethodGPoint': return this.renderMethodBoxGPoint(getAvailableShippingMethodByMethodName(typeName, this.state.shippingMethodsAvailable))
        default: return null
      }
    }).filter(item => item !== null)

    const groups = chunk(itemsRendered, 4)

    return (
      <React.Fragment>
        {groups.map((groupItems, index) => {
          return (
            <div key={index} className={cn(cg.gridX, cg.gridMarginX, ...(itemsRendered.length <= 2 ? [cg.mediumUp2, cg.largeUp2] : [ cg.mediumUp2, cg.largeUp4]))}>
              {groupItems}
            </div>
          )
        })}
        {(!itemsRendered.length || this.state.checkoutInfoFetching) && <Spinner overlay />}
      </React.Fragment>
    )
  }

  onGoToNextStep = async () => {
    const { cart } = this.props
    const selectedMethodName = this.state.shippingMethodNameSelected

    if (!selectedMethodName || !cart) {
      Logger.debug('VALIDATION: selectedMethodName/cart === null')
      return
    }

    if (!CheckoutHelper.isDeliveryAddressValid(this.props.deliveryAddress)) {
      showMessage('Válaszd ki, hogy hova szeretnél rendelni!')
      animateScrollTo(0)
      return
    }

    const selectedMethod = getAvailableShippingMethodByMethodName(selectedMethodName, this.state.shippingMethodsAvailable)
    if (!selectedMethod) {
      showMessage('A mai napon felvehető rendelési kapacitásunk megtelt! Megrendelésedet legközelebb a következő napon 00.00 perctől adhatod le.')
      return
    }

    if (this.props.session.loggedIn && this.props.linkableOrders.length && this.props.cart && !this.props.cart.linked_order) {
      const newCart = await new Promise<CartFragment | null>(resolve => {
          showLinkingOrdersModal(resolve)
      })
      if (newCart) {
        const steps = CheckoutHelper.getCheckoutSteps(this.props.deliveryAddress, this.props.session.loggedIn, newCart)
        const nextStep = CheckoutHelper.getNextCheckoutStep(CheckoutStage.CART, steps)
        if (nextStep) {
          gtmClientInstance.sendShippingInfo(this.props.cart);
        }
        nextStep && pushRoute(nextStep.href)
        return
      }
    }

    if (CheckoutHelper.methodHasAnyError(selectedMethod)) {
      CheckoutHelper.showErrorDialogForShippingErrors((selectedMethod.errors || []).filter(Boolean).map(error => error!.__typename))
      return
    }

    if (!cart.linked_order) {
      try {
        const result = await _app.apolloClient.mutate<updateCart, updateCartVariables>({
          mutation: updateCartMutation,
          variables: {
            input: {
              id: cart.id,
              shipping_method_id: selectedMethod.id,
              shipping_address: null
            }
          }
        })

        if (result.data && result.data.updateCart) {
          this.props.dispatch(setCart(result.data.updateCart))
        } else throw new Error('Received no data for updateCart')
      } catch(e) {
        const errors = collectAllErrorsForModal(e)
        showMessage(<>Hiba történt a szállítási mód beállítása közben: {errors}</>)
        return
      }
    }
    this.props.dispatch(refreshCheckoutInfo())

    // Set selected method to orderData
    Logger.debug('Everything is set')
    // If next step is express checkout move to express checkout page
    const steps = CheckoutHelper.getCheckoutSteps(this.props.deliveryAddress, this.props.session.loggedIn, this.props.cart)
    const nextStep = CheckoutHelper.getNextCheckoutStep(CheckoutStage.CART, steps)
    if (nextStep) {
      gtmClientInstance.sendShippingInfo(this.props.cart!);
      pushRoute(nextStep.href)
    } else {
      Logger.debug('Nowhere to go :(')
    }
  }

  render() {
    const { cart, deliveryAddress } = this.props

    if (!cart) {
      return null
    }

    const method = getAvailableShippingMethodByMethodName(this.state.shippingMethodNameSelected!, this.state.shippingMethodsAvailable)
    const weightLimit = method && method.max_weight || 0
    const hasWeightProblem = method && CheckoutHelper.methodHasWeightProblem(method) || false
    const hasProductsProblem = method && CheckoutHelper.methodHasProductsProblem(method) || false
    const totalWeight = CartHelper.getCartTotalWeight(cart.cart_products)
    const totalPrice = CartHelper.getCartTotalPrice(cart)

    const remainingAmountToFreeShipping = FREE_SHIPPING_LIMIT - cart.total_price
    const hasGiftBasket = cart.cart_products.some(cp => cp.product.gift_message_available)
    const showDeliveryDiscountInfo = deliveryAddress && deliveryAddress.selected.type === 'delivery' && (totalPrice > SHOW_FREE_SHIPPING_MINIMUM || hasGiftBasket) && !["ShippingMethodMpl", "ShippingMethodPostPoint"].includes(this.state.shippingMethodNameSelected!)

    const goToCheckoutDisabled = cart.cart_products.length === 0
    const sortedProducts = cartSorters[this.state.cartOrder](cart.cart_products)

    return (
      <div ref={ref => this.containerDiv = ref}>
        <Head>
          <title>Kosár</title>
        </Head>

        <AppBar
          viewType={AppBarViewType.CheckoutPage}
          pageTitle={"Kosár tartalma"}
          pageType="Checkout"
          breadcrumb="Checkout / Cart"
        />

        <GtmCheckoutStep
          step={1}
          isExpress={CheckoutHelper.isExpressCheckout(this.props.deliveryAddress, this.props.session, cart)}
          cart={cart}
        />

        <div className={cn(stepper.container)}>
          <Stepper stage={CheckoutStage.CART} />
          <h3>Kosár</h3>
        </div>

        <div className={cl.cartPage}>
          {cart.linked_order && (
            <div className={cn(cg.gridX, cl.alert, cl.linkedOrder)}>
              <div className={cn(cg.cell, cl.alertIcon)}>
                <SVGLink />
              </div>
              <div className={cn(cg.cell, cl.alertText)}>
                <p>
                  Rendelésed a következő megrendeléshez kapcsoltad, ezért a szállítási és számlázási adatok nem módosíthatóak!
                </p>
                <p>
                  <b>
                    {CheckoutHelper.formatLinkedOrder(cart)}
                    <a onClick={this.unlinkOrder} style={{ marginLeft: '15px' }}>Szétkapcsolom &gt;&gt;</a>
                  </b>
                </p>
              </div>
            </div>
          )}
          <div className={cn(cg.gridContainer, cl.cartPage__gridContainer, cl.cartPage__gridContainerSmallNoPadding)}>
            <div className={cl.cartPage__addressDisplayWrapper}>
              <AddressDisplay view='CartPage' />
            </div>
          </div>

          {!cart.linked_order &&
            <>
              <h3>Szállítási mód kiválasztása</h3>


              <div className={cn(cl.radioOptions)}>
                {this.renderAvailableMethods()}
              </div>
            </>
          }

          {method && hasWeightProblem && (
            <div className={cn(cg.gridX, cl.alert)}>
              <div className={cn(cg.cell, cl.alertIcon)}>
                <SVGIconWarningLabel />
              </div>
              <div className={cn(cg.cell, cl.alertText)}>
                <p>A kosarad tömege meghaladja a {method.name} rendelésenkénti, <span>{(method.max_weight || 0) / 1000} kg</span>-os maximumát.</p>
                <p><strong>Ezért javasoljuk, hogy csökkentsd le a kosárad összsúlyát: vegyél el, vagy törölj belőle termékeket.</strong></p>
              </div>
            </div>
          )}

          {hasProductsProblem && (
            <div className={cn(cg.gridX, cg.alignMiddle, cl.alert)}>
              <div className={cn(cg.cell, cl.alertIcon)}>
                <SVGIconWarningLabel />
              </div>
              <div className={cn(cg.cell, cl.alertText)}>
                <p>Nem szállítható termékeket tartalmaz a kosár</p>
                <p><strong>Ezért javasoljuk, hogy távolítsd el a kosaradból a megjelölt termékeket, vagy válassz másik szállítási módot.</strong></p>
              </div>
            </div>
          )}

          <h3 ref={ref => this.cartHeadingRef = ref}>
            <div className={cn(cg.gridX)}>
              <div className={cn(cg.cell, cg.auto, cg.alignSelfBottom)}>
                Kosár tartalma
              </div>
              <div className={cn(cg.cell, cg.shrink)}>
                <DropdownSelect<CartOrder>
                  items={[{ value: 'default', title: 'Kosárbahelyezés ideje szerint' }, { value: 'alphabetical', title: 'Termék neve A-Z' }]}
                  value={this.state.cartOrder}
                  name="CartOrder"
                  editingDisabled
                  isNullable={false}
                  onChange={(_,v) => this.setState({ cartOrder: v })}
                />
              </div>
            </div>
          </h3>

          <div className={cn(cg.gridContainer, cl.cartPage__gridContainer, cl.cartPage__gridContainerSmallNoPadding)}>
            <CartTable
              selectedMethod={this.state.shippingMethodNameSelected || null}
              availableShippingMethods={this.state.shippingMethodsAvailable}
              cartProducts={sortedProducts}
            />
          </div>

          <div className={cn(cg.gridContainer, cl.cartPage__gridContainer)}>
            <CartSummary
              total={CartHelper.getCartTotalPrice(cart)}
              totalWeight={totalWeight}
              weightLimit={weightLimit}
              hasWeightProblem={hasWeightProblem}
              showDiscounts={true}
              cartTotalPrice={cart.total_price}
              cartDiscountedPrice={cart.discount_price || cart.total_price}
              couponCode={cart.coupon_code || undefined}
            />

            {showDeliveryDiscountInfo && <div className={cl.cartPage__deliveryDiscountWrapper}>
              <DeliveryDiscount remaining={remainingAmountToFreeShipping} hasGiftBasket={hasGiftBasket} />
            </div>}

            <CartCoupon shippingMethodNameSelected={this.state.shippingMethodNameSelected} shippingMethodsAvailable={this.state.shippingMethodsAvailable} />
          </div>

          <div className={cn(cg.gridContainer, cl.cartPage__gridContainer, cl.cartPage__buttonContainer)}>
            <div className={cn(cg.gridX, cg.gridMarginX)}>
              <div className={cn(cg.cell, cg.smallOrder3, cg.mediumOrder1, cl.buttonContainer__controls)}>
                <div className={cn(cg.gridX, cg.gridMarginX, cg.alignCenter)}>

                  <div className={cn(cg.cell, ...(this.props.session.loggedIn ? [cg.small6, cg.mediumShrink] : [cg.small12, cg.mediumShrink]))}>
                    <button
                      onClick={this.handleDeleteAllClick}
                      className={cn(cg.gridX, cg.alignMiddle, cl.controlButton, ...(this.props.session.loggedIn ? [cl.controlButtonSmallAlignRight] : [cl.controlButtonSmallAlignCenter]) )}
                    >
                      <span className={cn(cg.cell, ...(this.props.session.loggedIn ? [cg.mediumShrink] : [cg.shrink]))} aria-hidden={true}>
                        <SVGTrashSmall width={32} height={32} />
                      </span>

                      <span className={cn(cg.cell, ...(this.props.session.loggedIn ? [cg.mediumAuto] : [cg.auto]))}>
                        Kosár ürítése
                      </span>
                    </button>
                  </div>

                  {this.props.session.loggedIn && (
                    <div className={cn(cg.cell, cg.small6, cg.mediumShrink)}>
                      <button className={cn(cg.gridX, cg.alignMiddle, cl.controlButton, cl.controlButtonSmallAlignLeft)} onClick={() => { uiEventEmitter.emit(UIEvents.SHOW_MODAL, <SaveCartToListModal cartProducts={cart.cart_products} callback={this.saveToShoppingListFinished} />)}}>
                        <span className={cn(cg.cell, cg.mediumShrink)} aria-hidden={true}>
                          <SVGList width={32} height={32} />
                        </span>

                        <span className={cn(cg.cell, cg.mediumAuto)}>
                          Kosár mentése bevásárlólistának
                        </span>

                      </button>
                    </div>
                    )}
                </div>
              </div>

              <div className={cn(cg.cell, cg.medium6, cg.textCenter, cg.mediumTextLeft, cg.mediumOrder2, cl.cell)}>
                <PageLink toPage="/" className={cn(btnCss.button, btnCss.hollow, cl.buttonLink)}>
                  Vásárlás folytatása
                </PageLink>
              </div>

              <div className={cn(cg.cell, cg.medium6, cg.textCenter, cg.mediumTextRight, cg.mediumOrder3, cl.cell)}>
                <Button disabled={goToCheckoutDisabled} onClick={this.onGoToNextStep} label={CheckoutHelper.getNextCheckoutButtonText(CheckoutStage.CART, this.props)} className={cn(btnCss.button, cl.buttonLink)} />
              </div>

            </div>
          </div>
        </div>

        {this.props.isMobile && cart.cart_products.length >= 7 && this.state.showScrollToBottom && <ScrollIntoViewButton
          onClick={this.scrollIntoView}
        />}
      </div>
    )
  }
}

const mapStateToProps = (state: Redux.IReduxState) => {
  return {
    cart: state.cart,
    orderData: state.orderData,
    deliveryAddress: state.deliveryAddress,
    session: state.session,
    linkableOrders: state.checkoutInfo.linkableOrders,
    isMobile: state.isMobile || state.isTablet
  }
}

export default connect(mapStateToProps)(CartPage)
